import { FrownOutlined } from '@ant-design/icons';
import * as Sentry from '@sentry/react';
import { useRouteError } from 'react-router-dom';
import type { TComponent } from 'utils/types/component';

import EmptyPage from 'components/ui/EmptyPage';

export const ErrorBoundary: TComponent = () => {
    const error = useRouteError();

    Sentry.captureException(error);

    return (
        <EmptyPage
            text='Что-то пошло не так'
            icon={FrownOutlined}
            actionHref='/'
            actionText='На главную'
        />
    );
};
